import React, { useEffect, useState } from 'react';
import { colors, css, fonts} from '../../Styles';
import { progressColor } from '../../Definitions';
import { progressTextColor } from '../../Definitions/progressColor';

interface ProgressBar_Props {
  total?: number
  progressed?: number
  isPrimaryBar?: boolean
  labelSecondaryBar?: string | number
  header?: string
  unit?: JSX.Element
  animation?: boolean
}
/**
 * ProgressBar
 * @param total 
 * @param progressed
 * @param isPrimaryBar
 * @param labelSecondaryBar
 * @param animation
 * @returns 
 */
export default function ProgressBar ({total = 0, progressed = 0, isPrimaryBar = true, labelSecondaryBar, header, unit, animation = false}:ProgressBar_Props) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const progressedPercentage = total > 0 ? (progressed / total) * 100 : 0;

  const _width = ( animation 
    ? animate 
      ? `${progressedPercentage}%` 
      : "0%"
    : `${progressedPercentage}%`
  )
  if (total === 0 || progressed === 0 || total === null || progressed === null) {
    return <div>No data</div>;
  }
  
  const progressBar = (
    <div style={{width: isPrimaryBar? "100px" : "80px", backgroundColor: isPrimaryBar ? colors.greyTertiary : colors.greyLightSecondary, height: isPrimaryBar? "15px" : "30px", position: "relative", borderRadius: isPrimaryBar ? "10px" : "0px", overflow: "hidden"}}>
      <div style={{backgroundColor: progressColor(progressedPercentage), height: "100%", width: _width, position: "absolute", left: "0px", transition: "width 1s ease"}}/>
      { isPrimaryBar
      ? <div style={{position: "absolute", display: "grid", gridTemplateColumns: "5fr 1fr 5fr", width: "100%", height: "100%"}}>
          <p style={{ ...css.progressBarLabel, justifyContent: "end" }}>{`${progressed}`}</p>
          <p style={{ ...css.progressBarLabel, justifyContent: "center" }}>/</p>
          <p style={{ ...css.progressBarLabel, justifyContent: "start" }}>{`${total}`}</p>
        </div>
      : <p style={{ position: "absolute", transform: "translateX(-50%)", left: "50%", ...css.progressBarText, color: progressTextColor(progressedPercentage) }}>{labelSecondaryBar}</p>
      }
    </div>
  )

  return (
     header ? (
      <div style={{height: "65px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: "9px"}}>
        <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, textAlign: "center"}}>{header}</p>
        {progressBar}
        {unit}
      </div> )
    : <>{progressBar}</>
  );
};